<script>
import {Line} from 'vue-chartjs'

export default {
  extends: Line,
  data() {
    return {
      chartdata: {
        datasets: [
          {
            label: 'Горячая',
            data: [],
            borderColor: "red",
            fill: false,
            borderWidth: 2,
            yAxisID: "yw",
          },
          {
            label: 'Холодная',
            data: [],
            borderColor: "blue",
            fill: false,
            borderWidth: 2,
            yAxisID: 'yw',
          },
          {
            label: 'Электричество',
            data: [],
            borderColor: "green",
            fill: false,
            borderWidth: 2,
            yAxisID: "ye",
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            position: 'bottom',
          }],
          yAxes: [
            {
              id: 'yw',
              type: 'linear',
              display: true,
              position: 'left',
            },
            {
              id: 'ye',
              type: 'linear',
              display: true,
              position: 'right',
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.$http("/user/data")
        .then(resp => {
          this.chartdata.datasets[0].data = resp.data["WATER_HOT"]
          this.chartdata.datasets[1].data = resp.data["WATER_COLD"]
          this.chartdata.datasets[2].data = resp.data["ELECTRO"]
          this.renderChart(this.chartdata, this.options)
        })
  }
}
</script>

<style>
</style>